import { ReactElement, ReactNode } from 'react';

interface IProps {
  when?: boolean;
  children: ReactElement | ReactElement[] | ReactNode;
}

const VisibleView = ({ when, children }: IProps) => {
  if (!when) {
    return null;
  }

  return <>{children}</>;
};

export default VisibleView;
